import { configureStore } from '@reduxjs/toolkit'
import headerSlice from '../features/common/headerSlice'
import modalSlice from '../features/common/modalSlice'
import rightDrawerSlice from '../features/common/rightDrawerSlice'
import leadsSlice from '../features/leads/leadSlice'
import authReducer from '../features/auth/authReducer'
import subscriptionReducer from '../features/subscriptions/subscriptionReducer'
import courseReducer from '../features/courses/courseReducer'
import lessonReducer from '../features/lessons/lessonReducer'
import categoryReducer from '../features/categories/categoryReducer'
import authorReducer from '../features/authors/authorReducer'
import userReducer from '../features/user/userReducer'
import usersReducer from '../features/users/userReducer'
import eventReducer from '../features/events/eventReducer'
import videoProcessingReducer from '../features/courses/videoProcessingSlice'
import dashboardReducer from '../features/dashboard/dashboardReducer'
import quizReducer from '../features/quizzes/quizReducer'
import quizQuestionsReducer from '../features/quizQuestions/quizQuestionsReducer'
import associationReducer from '../features/associations/associationReducer'
import voucherReducer from '../features/vouchers/voucherReducer'

const combinedReducer = {
  header : headerSlice,
  rightDrawer : rightDrawerSlice,
  modal : modalSlice,
  lead : leadsSlice,
  auth : authReducer,
  subscription : subscriptionReducer,
  course : courseReducer,
  lesson : lessonReducer,
  category : categoryReducer,
  author : authorReducer,
  user : userReducer,
  users : usersReducer,
    event : eventReducer,
    videoProcessing : videoProcessingReducer,
    dashboard : dashboardReducer,
    quiz : quizReducer,
    quizQuestions : quizQuestionsReducer,
    association : associationReducer,
    voucher : voucherReducer
}

export default configureStore({
    reducer: combinedReducer
})